<template>
    <div v-if="!icon && !!src">
        <div :style="style" v-if="!!color"></div>
        <img :height="iconSize" :src="requiredSrc" :width="iconSize" v-else>
    </div>
    <component
            :is="iconComponent"
            v-else-if="!!icon && !!iconComponent"
            :icon="icon"
            :fill-color="resolvedColor"
    ></component>
</template>

<script>
    export default {
        props: {
            src: {
                type: [String, null]
            },
            color: {
                type: [String, null],
                default: null
            },
            size: {
                type: [String, Number, null],
                default: 24
            },
            icon: {
                type: [String, null],
                default: null
            },
        },
        data: () => ({
            iconSize: null,
            iconLibrary: {
                'play': () => import('vue-material-design-icons/Play.vue'),
                'link': () => import('vue-material-design-icons/Link.vue'),
                'apple': () => import('vue-material-design-icons/Apple.vue'),
                'google-play': () => import('vue-material-design-icons/GooglePlay.vue'),
                'text-short': () => import('vue-material-design-icons/TextShort.vue'),
                'close': () => import('vue-material-design-icons/Close.vue'),
                'puzzle': () => import('vue-material-design-icons/Puzzle.vue'),
                'cloud-check': () => import('vue-material-design-icons/CloudCheck.vue'),
                'fingerprint': () => import('vue-material-design-icons/Fingerprint.vue'),
                'cellphone-link': () => import('vue-material-design-icons/CellphoneLink.vue'),
                'check-all': () => import('vue-material-design-icons/CheckAll.vue'),
                'trending-up': () => import('vue-material-design-icons/TrendingUp.vue'),
                'refresh': () => import('vue-material-design-icons/Refresh.vue'),
                'sync': () => import('vue-material-design-icons/Sync.vue'),
                'account-check': () => import('vue-material-design-icons/AccountCheck.vue'),
                // 'poll-box-outline': () => import('vue-material-design-icons/PollBoxOutline.vue'),
                'desktop-mac-dashboard': () => import('vue-material-design-icons/DesktopMacDashboard.vue'),
                'domain': () => import('vue-material-design-icons/Domain.vue'),
                'account-multiple': () => import('vue-material-design-icons/AccountMultiple.vue'),
                'message-reply-text': () => import('vue-material-design-icons/MessageReplyText.vue'),
                'school': () => import('vue-material-design-icons/School.vue'),
                'star-circle': () => import('vue-material-design-icons/StarCircle.vue'),
                'book-open-variant': () => import('vue-material-design-icons/BookOpenVariant.vue'),
                'clipboard-account': () => import('vue-material-design-icons/ClipboardAccount.vue'),
                'bank': () => import('vue-material-design-icons/Bank.vue'),
                'security': () => import('vue-material-design-icons/Security.vue'),
                'chart-line-variant': () => import('vue-material-design-icons/ChartLineVariant.vue'),
                'file-document': () => import('vue-material-design-icons/FileDocument.vue'),
                'clipboard-text': () => import('vue-material-design-icons/ClipboardText.vue'),
                'arrow-right': () => import('vue-material-design-icons/ArrowRight.vue'),
                'arrow-left': () => import('vue-material-design-icons/ArrowLeft.vue'),
                'code-tags': () => import('vue-material-design-icons/CodeTags.vue'),
                'account': () => import('vue-material-design-icons/Account.vue'),
                'google-chrome': () => import('vue-material-design-icons/GoogleChrome.vue'),
                'firefox': () => import('vue-material-design-icons/Firefox'),
                'microsoft-edge': () => import('vue-material-design-icons/MicrosoftEdge.vue'),
                'menu-down': () => import('vue-material-design-icons/MenuDown.vue'),
                'menu': () => import('vue-material-design-icons/Menu.vue'),
                'circle-medium': () => import('vue-material-design-icons/CircleMedium.vue'),
                'account-supervisor': () => import('vue-material-design-icons/AccountSupervisor.vue'),
                'poll': () => import('vue-material-design-icons/Poll.vue'),
                'star-outline': () => import('vue-material-design-icons/StarOutline.vue'),
                'school-outline': () => import('vue-material-design-icons/SchoolOutline.vue'),
                'credit-card-outline': () => import('vue-material-design-icons/CreditCardOutline.vue'),
                'cog-outline': () => import('vue-material-design-icons/CogOutline.vue'),
                'email-outline': () => import('vue-material-design-icons/EmailOutline.vue'),
                'cellphone': () => import('vue-material-design-icons/Cellphone.vue'),
                'youtube': () => import('vue-material-design-icons/Youtube.vue'),
                'linkedin': () => import('vue-material-design-icons/Linkedin.vue'),
                'vimeo': () => import('vue-material-design-icons/Vimeo.vue'),
                'earth': () => import('vue-material-design-icons/Earth.vue'),
            },
            iconComponent: null
        }),
        computed: {
            style() {
                return {
                    maskImage: 'url("' + this.requiredSrc + '")',
                    maskRepeat: 'no-repeat',
                    maskPosition: 'center',
                    maskSize: 'contain',
                    width: this.iconSize,
                    height: this.iconSize,
                    backgroundColor: this.resolvedColor
                }
            },
            requiredSrc() {
                if(!this.icon) {
                    return require('@/assets/icons/' + this.src);
                }
                return null;
            },
            resolvedColor() {
                return this.$theme.colors[this.color] || this.color;
            }
        },
        watch: {
            icon() {
                this.importIcon();
            },
        },
        methods: {
            importIcon() {
                if (this.icon) {
                    if(!this.iconLibrary[this.icon]) {
                        throw new Error('Icon: The \'' + this.icon + '\' is not defined. Remember to add the icon to the library.');
                    }
                    this.iconLibrary[this.icon]().then((module) => {
                        this.iconComponent = module.default
                    });
                } else {
                    this.iconComponent = null;
                }
            }
        },
        mounted() {
            if (!this.src && !this.icon) {
                throw new Error('Icon: Either the src prop or the icon prop is required.');
            } else {
                this.iconSize = this.size ? this.size.toString().replace('px', '') + 'px' : '25px';
            }
            this.importIcon();
        }
    };
</script>
